import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";

function routeFromAppUrl(url) {
  if (!url) return null;

  try {
    const parsed = new URL(url);

    if (parsed.hash && parsed.hash.startsWith("#/")) {
      return parsed.hash.slice(1);
    }

    if (parsed.pathname && parsed.pathname !== "/") {
      return parsed.pathname + parsed.search;
    }
  } catch (_err) {
    return null;
  }

  return null;
}

export function initDeepLinks(router) {
  if (!Capacitor.isNativePlatform()) return;

  CapacitorApp.addListener("appUrlOpen", ({ url }) => {
    const route = routeFromAppUrl(url);
    if (!route) return;

    if (router.currentRoute.fullPath !== route) {
      router.push(route).catch(() => {});
    }
  });
}
